import { Component, Vue } from "vue-property-decorator";
import { IndexHeader } from "@/components/IndexHeader";
import { IndexFooter } from "@/components/IndexFooter";
import { Banner } from "./components/Banner/index";
import { Prospect } from "./components/Prospect/index";
import { Product } from "./components/Product/index";
import { Features } from "./components/Features/index";
import { Outline } from "./components/Outline/index";
import { Project } from "./components/Project/index";
import { Obtain } from "./components/Obtain/index";
import { EqualPosition } from "./components/EqualPosition/index";
import { SuitableLearning } from "./components/SuitableLearning/index";
import { TryVideo } from "./components/TryVideo/index";
import { Student } from "./components/Student/index";
import { Teacher } from "./components/Teacher/index";
import { QA } from "./components/QA/index";
Component.registerHooks(["asyncData"]);
@Component({
    components: {
        IndexHeader,
        IndexFooter,
        Banner,
        Prospect,
        Product,
        Features,
        Outline,
        Project,
        Obtain,
        EqualPosition,
        SuitableLearning,
        TryVideo,
        Student,
        Teacher,
        QA
    }
})
export default class infoMiddle extends Vue {
    private currentPageConfigData: any = {};
    private currentCatalog: any = {};
    private seriesId: number | undefined;
    created(): void {
        this.seriesId = Number(this.$route.params.courseSeriesId);
        this.currentPageConfigData = JSON.parse(
            this.courseData.currentPageConfig.pageConfig
        );
        this.currentCatalog = this.courseData.currentCatalog;
    }
    asyncData({ store, route }) {
        return store.dispatch("details/fetchInfoItem", {
            courseSeriesId: route.params.courseSeriesId
        });
    }
    get courseData() {
        return this.$store.state.details.config;
    }
}
